import {Fragment} from "react";
import PlayerLink from "./PlayerLink";
import {scorerNameKey} from "@/lib/scorer-directory-data";
export default function PlayerGoalAuthors({text,team,scorers}:{text:string;team:string;scorers:{id:number;playerName:string;team:string}[]}){
 return <>{(text||"—").split(", ").map((part,i)=>{
 const name=part.split(/ ×| \(/)[0];const found=scorers.filter(s=>s.team===team&&scorerNameKey(s.playerName)===scorerNameKey(name));
 return <Fragment key={i}>{i?", ":""}{found.length===1?<PlayerLink id={found[0].id} name={name}>{part}</PlayerLink>:part}</Fragment>;
 })}</>;
}
